export default __webpack_public_path__ + "static/media/Apple logo 1.93663d3b.svg";